import type { FaireProductEntity } from "../../entity_types/product";

export const p_mw6xx8cs5w: FaireProductEntity = {
  token: "p_mw6xx8cs5w",
  type: "product",
  name: "Recipes from the Rum Islands",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/248b2d74ad64f2baef4c56bfe45063277f510a348e50797133df736466f5e020.jpeg",
  galleryImageUrls: [],
  priceDollars: 14,
  description: "This is a black and white reissue edition of Caribbean Modern, previously published as a full-colour cookbook in 2015. This edition contains no photography.\n\nWhen you think of the Caribbean, a hundred beautiful clichés come to mind - white sand, blue sky, salty breezes and balmy nights. But what of the food? Eating is at the heart of Caribbean life: people come together in the kitchen, someone starts cooking and soon there is laughter, music and fantastic food.\n\nShivi Ramoutar grew up in Trinidad, Leicester and London. As a supper club host and pop-up chef, Shivi turned to her favourite Caribbean dishes for inspiration. Her recipes are a wonderful melting pot of flavours: traditional Coconut Chicken Rundown sits alongside Red Bean and Spinach Mac 'n' Cheese and Baked Eggs Creole. Her food is fresh and zingy, exciting and exotic, but also satisfyingly homely and hearty. And not forgetting fun - Salted Tamarind Caramel Sundae, Smashed Banana Pancakes and Peanut Butter and Jelly Cheesecake - without which the book just wouldn't be Caribbean.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:53.182Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
